'use strict';

import $ from 'jquery';
import UserValidator from '@/js/modules/user_validator';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(document).on('submit', '.change-password-form', function () {
    let error = '';
    const $form = $(this);
    const $submit = $form.find('button[type=submit]');
    const password = $form.find('#user_password').val();
    const passwordConfirmation = $form.find('#user_password_confirmation').val();

    error = UserValidator.validatePassword(password);
    $('label.form-error[for=user_password]')
      .text(error)
      .css('display', error === '' ? 'none' : 'block');

    error = UserValidator.validatePasswordConfirmation(password, passwordConfirmation);
    $('label.form-error[for=user_password_confirmation]')
      .text(error)
      .css('display', error === '' ? 'none' : 'block');

    if ($('.form-error:visible').length) {
      $('.form-error:visible:first').focus();
      return false;
    }

    $submit.addClass('button-loading').prop('disabled', true);
  });
});
